import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const loginHistoryModule = {
  namespaced: true,
  state: {
    loginHistorys: null,
    loginHistory: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default loginHistoryModule;
